import { Project } from '@dc-shared-web/hooks/api/project/types'
import { CubeProject, mapCubeToProject } from '@dc-shared-web/lib'
import { AxiosInstance } from 'axios'

type GetProjectForMoveQueryParams = {
  currentTeamId: number
}

export const fetchProjectsForMove = async (
  apiClient: AxiosInstance,
  params: GetProjectForMoveQueryParams
): Promise<Project[]> => {
  const {
    data: { data },
  } = await apiClient.get(`/ajax/cube/move_projects`, { params })

  return data
    .map((cubeProject: CubeProject) => mapCubeToProject(cubeProject))
    .sort((a: Project, b: Project) => {
      // Compare the project names and return -1, 0, or 1
      const nameA = a.name.toString().toLowerCase()
      const nameB = b.name.toString().toLowerCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
}
